import { Action, createReducer, on } from '@ngrx/store';
import {
  ClearStateAction,
  DeliveryLocationAction,
  DeliveryLocationErrorAction,
  DeliveryLocationSuccessAction,
  getChooseLocationAction,
  getChooseLocationErrorAction,
  getChooseLocationSuccessAction,
  getLocationMenusAction,
  getLocationMenusErrorAction,
  getLocationMenusSuccessAction,
  getLocationTimeslotAction,
  getLocationTimeslotErrorAction,
  getLocationTimeslotSuccessAction,
  removeAcceptedAgeRestrictionYear,
  setAcceptedAgeRestrictionYears,
  setLocationPropTypes,
  SetSelectedLocationAction,
  SetSelectedTimeslotAction,
  setTimeslotExpiredAction,
} from './choose-location.actions';
import { ChooseLocationState } from './choose-location.state';

const initialState = new ChooseLocationState();

const reducer = createReducer(
  initialState,
  on(getChooseLocationAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getChooseLocationSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.chooseLocation = payload;
    return newState;
  }),
  on(getChooseLocationErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),

  on(getLocationTimeslotAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getLocationTimeslotSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.locationTimeslot = payload;
    return newState;
  }),
  on(getLocationTimeslotErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),

  on(getLocationMenusAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    newState.isMenuLoading = true;
    return newState;
  }),
  on(getLocationMenusSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isMenuLoading = false;
    newState.failures = null;
    newState.locationMenus = payload;
    return newState;
  }),
  on(getLocationMenusErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),

  on(DeliveryLocationAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(DeliveryLocationSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.deliveryLocation = payload.deliveryLocation;
    return newState;
  }),
  on(DeliveryLocationErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(SetSelectedLocationAction, (state, { selectedLocation }) => {
    const newState = { ...state };
    newState.selectedLocation = selectedLocation;
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),

  on(setLocationPropTypes, (state, { locationPropTypes }) => {
    const newState = { ...state };
    newState.locationPropTypes = locationPropTypes;
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),

  on(SetSelectedTimeslotAction, (state, { selectedTimeslot }) => {
    const newState = { ...state };
    newState.selectedTimeslot = selectedTimeslot;
    newState.isTimeslotExpired = false;
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(setTimeslotExpiredAction, (state, { isTimeslotExpired }) => {
    const newState = { ...state };
    newState.isTimeslotExpired = isTimeslotExpired;
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(setAcceptedAgeRestrictionYears, (state, { year }) => {
    const newState = { ...state };
    const acceptedAgeRestrictionYears = newState.acceptedAgeRestrictionYears;
    if (acceptedAgeRestrictionYears) {
      newState.acceptedAgeRestrictionYears = [...new Set([...acceptedAgeRestrictionYears, year])];
    } else {
      newState.acceptedAgeRestrictionYears = [year];
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(removeAcceptedAgeRestrictionYear, (state, { year }) => {
    const newState = { ...state };
    const acceptedAgeRestrictionYears = newState.acceptedAgeRestrictionYears;
    newState.acceptedAgeRestrictionYears = acceptedAgeRestrictionYears.filter((y) => y !== year);
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(ClearStateAction, (state, payload) => {
    const newState = { ...state };
    switch (payload.actionType) {
      case 'locationMenus':
        newState.locationMenus = null;
        break;
      case 'chooseLocation':
        newState.chooseLocation = null;
        break;
      case 'timeslots':
        newState.locationTimeslot = null;
        break;
      case 'selectedLocation':
        newState.selectedLocation = null;
        break;
      case 'selectedTimeslot':
        newState.selectedTimeslot = null;
        break;
      case 'acceptedAgeRestrictionYears':
        newState.acceptedAgeRestrictionYears = [];
        break;

      default:
        break;
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  })
);

export function ChooseLocationReducer(state: ChooseLocationState | null, action: Action) {
  return reducer(state, action);
}
